<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import {mapState} from "vuex";
    import {serbianDateFormat} from "@/state/helpers";

    export default {
        page: {
            title: "Invoices",
            meta: [{ name: "description", content: '' }],
        },
        components: {
            Layout,
            PageHeader
        },
        data () {
            return {
                title: 'Invoices',
                paidAtFilter: 'Not paid yet',
                currentPage: 1,
                pageSize: 15,
                startDate: '',
                endDate: ''
            }
        },
        computed: {
            ...mapState('invoices', {
                invoices: (state) => state.clientInvoices
            }),
            filteredInvoices () {
                // TODO: find more general solution for timezone problem
                // initialise Dates here because Vue can't watch for changes in Date() constructor,
                // this way computed property will recompute when this.startDate/endDate  is changed
                let startDate = this.startDate;
                let endDate = this.endDate;
                // subtract 2 hours from selected Dates so that filtered dates
                // correspond well to dates in invoices columns because they are in Serbian time zone
                startDate = (new Date(startDate)).setHours(new Date(startDate).getHours() - 2);
                endDate = (new Date(endDate)).setHours(new Date(endDate).getHours() - 2);
                // increment 1 day for end Date
                endDate = (new Date(endDate)).setDate((new Date(endDate)).getDate() + 1);

                return this.invoices.filter(item => {
                    let paidAtFilter = true;
                    if (this.paidAtFilter !== 'All') {
                        paidAtFilter = this.paidAtFilter === 'Not paid yet' ? !item.paid_at : item.paid_at;
                    }
                    return  (startDate ? new Date(item.created_at).getTime() >= new Date(startDate).getTime() : true) &&
                        (endDate ? new Date(item.created_at).getTime() <= new Date(endDate).getTime() : true) &&
                        paidAtFilter
                });
            },
            currentPageInvoices () {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;
                return this.filteredInvoices.slice(start, end);
            }
        },
        created () {
            this.currentPage = this.$route.query.page || 1;
        },
        methods: {
            serbianDateFormat: serbianDateFormat,
        }
    };
</script>

<template>

    <Layout>
        <PageHeader :title="title"/>
        <div class="row mb-2">
            <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                <div class="form-group mb-0">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-datepicker  placeholder="Select start Date"
                                                reset-button
                                               label-reset-button="Clear date"
                                               :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }"
                                               v-model="startDate"></b-form-datepicker>
                        </div>
                        <div class="col-md-6">
                            <b-form-datepicker placeholder="Select end Date"
                                               reset-button
                                               label-reset-button="Clear date"
                                               :min="startDate" :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }"
                                               v-model="endDate"></b-form-datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col d-flex align-items-end justify-content-end">
                <b-dropdown dropleft variant="info" size="sm">
                    <template slot="button-content">
                        <i class="mdi mdi-chevron-left"></i>
                        Filter: {{ paidAtFilter }}
                    </template>
                    <b-dropdown-item-button @click="paidAtFilter = 'Paid'">Paid</b-dropdown-item-button>
                    <b-dropdown-item-button @click="paidAtFilter = 'Not paid yet'">Not paid yet</b-dropdown-item-button>
                    <b-dropdown-item-button @click="paidAtFilter = 'All'">All</b-dropdown-item-button>
                </b-dropdown>
            </div>
        </div>

        <div class="invoices-container">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive mb-0">
                        <table class="table table-centered table-nowrap text-center">
                            <thead class="thead-light">
                            <tr>
                                <th class="text-left">#</th>
                                <th class="text-left">{{ $t('Invoice number') }}</th>
                                <th class="text-left">{{ $t('Number of posts') }}</th>
                                <th class="text-left">{{ $t('Created') }}</th>
                                <th class="text-left">{{ $t('Due date') }}</th>
                                <th class="text-right">{{ $t('Subtotal') }}</th>
                                <th class="text-right">{{ $t('Fee') }}</th>
                                <th class="text-right">{{ $t('VAT') }}</th>
                                <th class="text-right">{{ $t('Total amount') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(invoice, index) in currentPageInvoices" :key="index">
                                <td class="text-left">{{ index + 1 }}</td>
                                <td class="text-left"><a download :href="invoice.invoice_url">{{ `${(new
                                    Date(invoice.created_at)).getFullYear()}/${invoice.invoice_number_in_current_year}`
                                    }}</a></td>
                                <td class="text-left">{{ invoice.invoicable_posts_count }}</td>
                                <td class="text-left">{{ serbianDateFormat(invoice.created_at) }}</td>
                                <td class="text-left">{{ serbianDateFormat(invoice.due_date) }}</td>
                                <td class="text-right font-weight-bold">{{
                                    parseFloat(invoice[`subtotal_${invoice.currency}`]).toLocaleString() }} <span
                                            v-html="invoice.currencySymbol"></span></td>
                                <td class="text-right font-weight-bold">{{
                                    parseFloat(invoice[`fee_${invoice.currency}`]).toLocaleString() }} <span
                                            v-html="invoice.currencySymbol"></span></td>
                                <td class="text-right font-weight-bold">{{
                                    parseFloat(invoice[`vat_${invoice.currency}`]).toLocaleString() }} <span
                                            v-html="invoice.currencySymbol"></span></td>
                                <td class="text-right font-weight-bold">{{
                                    parseFloat(invoice[`total_${invoice.currency}`]).toLocaleString() }} <span
                                            v-html="invoice.currencySymbol"></span></td>
                            </tr>
                            </tbody>
                        </table>
                        <b-pagination
                                v-model="currentPage"
                                :total-rows="filteredInvoices.length"
                                :per-page="pageSize"
                                aria-controls="my-table"
                                class="justify-content-center mt-3"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
    .invoices-container {
        min-height: 60vh;
    }
</style>
